import { gql } from "@apollo/client";

import { SEARCH_SUGGESTIONS_FRAGMENT } from "constants/suggestions";

export const SEARCH_PUBLIC_WORKER_POOL_SCHEDULABLE_RUNS = gql`
  query SearchPublicWorkerPoolSchedulableRuns($input: SearchInput!) {
    publicWorkerPool {
      schedulableRunsCount
      usersCount
      searchSchedulableRuns(input: $input) {
        edges {
          cursor
          node {
            isModule
            position
            stackId
            stackName
            provider
            run {
              id
              type
              title
              finished
              triggeredBy
              createdAt
              updatedAt
              driftDetection
              isPrioritized
              state
              commit {
                authorName
                hash
                url
              }
            }
            space {
              id
              accessLevel
            }
            version
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;

export const SEARCH_PUBLIC_WORKER_POOL_SCHEDULABLE_RUNS_SUGGESTIONS = gql`
  query SearchPublicWorkerPoolSchedulableRunsSuggestions($input: SearchSuggestionsInput!) {
    publicWorkerPool {
      schedulableRunsCount
      usersCount
      searchSchedulableRunsSuggestions(input: $input) {
        ...SearchSuggestionsFragment
      }
    }
  }
  ${SEARCH_SUGGESTIONS_FRAGMENT}
`;
